export const formulaTerms = [
  {
    symbol: 'c',
    name: 'The Constant',
    role: 'The Foundation',
    body: 'The immutable quality set by Adrian Kays and the underlying private family. It establishes the optimal conditions for maximum growth.',
  },
  {
    symbol: 'z²',
    name: 'The Recursion',
    role: 'The Ecosystem',
    body: 'A closed-loop network of brands and platforms where the output of one business unit becomes the input of another — without decay.',
  },
  {
    symbol: 'z',
    name: 'The Emergent',
    role: 'The Archetype',
    body: 'The necessary outcome: a high-performing archetype of global investors, entrepreneurs and leaders who demand holistic excellence.',
  },
];
